import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=1fa6094a&scoped=true&"
import script from "./TableCell.vue?vue&type=script&lang=ts&"
export * from "./TableCell.vue?vue&type=script&lang=ts&"
import style0 from "./TableCell.vue?vue&type=style&index=0&id=1fa6094a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa6094a",
  null
  
)

export default component.exports